import { consts } from '@allesauto/utils/consts';

import {
  DELETE_VEHICLE_CONDITION_FILTER,
  SET_VEHICLE_CONDITION_FILTER,
} from '@/store/redux/actions/pages/pcp';
import { IReduxActionProps } from '@/store/redux/Utils';

import { RESET_VEHICLE_CONDITION_FILTER } from './../../../../../actions/pages/pcp/filters/vehicleCondition/index';

export interface VehicleConditionStateProps {
  condition: string[];
  mileage: number | null;
  minYear: number | null;
  maxYear: number | null;
  maxOwners?: number | null;
  filterCount?: number;
}

export const InitialVehicleConditionFilterState: VehicleConditionStateProps = {
  condition: [],
  mileage: null,
  minYear: null,
  maxYear: null,
  maxOwners: null,
  filterCount: 0,
};

const VehicleCondtitionFilterState = (
  state: VehicleConditionStateProps = InitialVehicleConditionFilterState,
  action: IReduxActionProps
) => {
  switch (action.type) {
    case SET_VEHICLE_CONDITION_FILTER: {
      const value = action.payload as VehicleConditionStateProps;
      const {
        PCP: {
          FILTERS: {
            VEHICLE_CONDITION: {
              PREVIOUS_OWNERS_SLIDER_VALUES: { max: maxOwners },
            },
          },
        },
      } = consts;

      return {
        ...value,
        filterCount:
          (value.condition ? value.condition.length : 0) +
          (value.mileage ? 1 : 0) +
          (value.minYear ? 1 : 0) +
          (value.maxYear ? 1 : 0) +
          (value.maxOwners && value.maxOwners != maxOwners ? 1 : 0),
      };
    }
    case DELETE_VEHICLE_CONDITION_FILTER: {
      const vehicleConditionPayloadKey: keyof Omit<
        VehicleConditionStateProps,
        'filterCount'
      > =
        (action.payload?.condition && 'condition') ||
        (action.payload?.mileage && 'mileage') ||
        (action.payload?.minYear && 'minYear') ||
        (action.payload?.maxYear && 'maxYear') ||
        ((action.payload?.maxOwners || action.payload?.maxOwners === 0) &&
          'maxOwners');

      const vehicleConditionPayloadValue = action.payload?.condition;
      let vehicleConditionValues;

      if (vehicleConditionPayloadKey === 'condition') {
        const index =
          state[vehicleConditionPayloadKey] &&
          state[vehicleConditionPayloadKey].indexOf(
            vehicleConditionPayloadValue
          );

        vehicleConditionValues = [
          ...state[vehicleConditionPayloadKey].slice(0, index),
          ...state[vehicleConditionPayloadKey].slice(index + 1),
        ];
      } else if (
        vehicleConditionPayloadKey === 'minYear' ||
        vehicleConditionPayloadKey === 'maxYear'
      ) {
        const filterCountToDecrease =
          state['minYear'] && state['maxYear'] ? 2 : 1;

        return {
          ...state,
          minYear: null,
          maxYear: null,
          filterCount:
            state.filterCount && state.filterCount - filterCountToDecrease,
        };
      } else {
        vehicleConditionValues = null;
      }

      return {
        ...state,
        [vehicleConditionPayloadKey]: vehicleConditionValues,
        filterCount: state.filterCount && state.filterCount - 1,
      };
    }
    case RESET_VEHICLE_CONDITION_FILTER:
      return InitialVehicleConditionFilterState;
    default:
      return state;
  }
};

export default VehicleCondtitionFilterState;
